// extracted by mini-css-extract-plugin
module.exports = {"landing_page_GG":"GG_landing_page_GG__3QdHE"};